"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calcPosition = exports.DropDownWrapper = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const TRAVEL_DATES_FIELD_WIDTH = 770;
const MAX_TABLET_SCREEN_WIDTH = 1279;
exports.DropDownWrapper = styled_components_1.default.div({
    position: 'relative',
});
const calcPosition = (side, position) => {
    const screenWidth = window.outerWidth;
    if (screenWidth <= MAX_TABLET_SCREEN_WIDTH) {
        switch (side) {
            case `${position}`:
                return '0';
            case 'center':
                return `calc((100% - ${TRAVEL_DATES_FIELD_WIDTH}px) / 2)`;
            default:
                return 'auto';
        }
    }
    else {
        if (side === position)
            return '0';
        else
            return 'auto';
    }
};
exports.calcPosition = calcPosition;
const AbsoluteDropdownBox = styled_components_1.default.div(({ side }) => ({
    right: (0, exports.calcPosition)(side, 'rightSide'),
    left: (0, exports.calcPosition)(side, 'leftSide'),
}), ({ theme }) => (Object.assign({}, theme.modals.absoluteDropdownBox)));
const AbsoluteDropdown = (0, react_1.forwardRef)((props, ref) => {
    const { isShown = true, children, className = '' } = props, divProps = __rest(props, ["isShown", "children", "className"]);
    return isShown ? (react_1.default.createElement(AbsoluteDropdownBox, Object.assign({ className: `absolute-dropdown ${className}`, ref: ref }, divProps), children)) : null;
});
exports.DropDownWrapper.displayName = 'DropDownWrapper';
AbsoluteDropdown.displayName = 'AbsoluteDropdown';
exports.default = AbsoluteDropdown;
//# sourceMappingURL=AbsoluteDropdown.js.map